module.exports = __webpack_public_path__ + "static/media/3.6eb4dd97.jpg";